import script from "./NextTd.vue?vue&type=script&setup=true&lang=ts"
export * from "./NextTd.vue?vue&type=script&setup=true&lang=ts"

import "./NextTd.vue?vue&type=style&index=0&id=04111c0c&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04111c0c"]])

export default __exports__